import {
  ExportFinanceFactSummaryDocument,
  ExportFinanceFactSummaryMutation,
} from 'generated/resources/graphql'
import { compact } from 'lodash'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { TableDataVariables } from 'modules/finance/components/FinancialWorkspace/types/table'
import { useCustomFilters } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/CustomFilters'
import { useSourcesVisibility } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useSourcesVisibility'
import { getFilteredVariables } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/lib/filteredVariables'
import { getFinanceTypes } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/lib/sources'

export const useOnExport = (variables: TableDataVariables) => {
  const [exportFinanceFactSummary] = useMutation(ExportFinanceFactSummaryDocument, {
    extractorFn: (data: ExportFinanceFactSummaryMutation) =>
      data.financialWorkspaceMutations.exportFinancialworkspaceExportExportFinanceFactSummary,
  })

  const visibility = useSourcesVisibility()

  const { formattedState: customFilters } = useCustomFilters()

  const onExport = async () => {
    const financeTypes = getFinanceTypes(visibility)
    const customCategoryIds = compact(
      financeTypes.includes('expense')
        ? customFilters?.employeeCosts?.employee_expenses.map((i) => String(i))
        : []
    ).filter(Boolean)

    const result = await exportFinanceFactSummary({
      variables: {
        ...variables,
        financeTypes,
        ...getFilteredVariables({
          customCategoryIds,
          formattedState: variables,
          agreementDataTypes: customFilters.employeeCosts?.agreement_data || [],
        }),
      },
    })

    const handledResult = handleResult(result, () => undefined)

    if (handledResult.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('data_table.export.success'),
        time: 3000,
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
  }

  return { onExport }
}
